<template>
  <div
    class="box is-marginless is-radiusless has-text-justified"
    @click="emitClick"
  >
    <router-link :to="{ name: 'agent', params: { slug: agent.slug } }">
      <div class="is-inline-block-desktop has-text-weight-semibold"> {{ agent.trivial_name | capitalizeFirstLetter }}</div>
      <div class="is-inline-block-desktop"> {{ agent.name }}</div>
      <div class="is-inline-block-desktop"> CAS:{{ agent.cas_number }}</div>
      <div class="is-inline-block-desktop"> UN:
        <span
          v-for="(un,idx) in agent.un_numbers"
          :key="idx"
        >
          {{ un }}
        </span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    agent: {
      type: Object,
      required: true
    }
  },
  methods: {
    emitClick () {
      this.$emit('list-item-clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  div {
    margin-right: 15px;
  }
}
</style>
